import React, { useEffect, useMemo } from 'react';
import { Typography } from '@guildeducationinc/recess';
import { Footer } from 'src/components/Quiz/Footer';
import { RoundIconButton } from 'src/components/Quiz/RoundIconButton';
import { AnswerKeys, QuizAnalytics, ScreenProps } from '@src/containers/QuizContainer/types';
import { trackEvent } from 'src/services/analytics';
import { QuizQuestion } from 'src/components/Quiz/QuizQuestion';
import { useQuiz } from '@src/components/Providers/QuizProvider';
import { programFactorCategories } from './programFactorCategories';
import styles from './ProgramFactor.module.scss';

const question = 'When choosing a program, what factor is most important to you?';

export const ProgramFactor: React.FC<ScreenProps> = props => {
	const { answers } = useQuiz();
	const { defaultAnswers, nextScreen, previousScreen, updateAnswers } = props;

	const selectedFactor = answers?.factor ? answers.factor : defaultAnswers?.factor || undefined;

	const analyticsData: QuizAnalytics = useMemo(() => {
		return {
			questionKey: question,
			questionType: 'radioButtons',
		};
	}, []);

	useEffect(() => {
		updateAnswers({ [AnswerKeys.factor]: selectedFactor }, answers);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		trackEvent('userProgramQuizQuestionAttempted', analyticsData);
	}, [analyticsData]);

	return (
		<div data-testid='program-factor'>
			<fieldset className='borderWidth--0'>
				<legend className={styles.title} id='factor-label'>
					<QuizQuestion question={question} />
				</legend>
				<Typography className={styles.helperText} variant='body1'>
					This won&apos;t impact your recommendations, but it helps our coaches.
				</Typography>
				<div className={styles.categoriesWrapper}>
					{programFactorCategories.map(f => (
						<RoundIconButton
							icon={f.icon}
							key={f.label}
							label={f.label}
							onClick={() => {
								analyticsData.responseKey = f.label;
								updateAnswers({ [AnswerKeys.factor]: f.label }, answers);
							}}
							role='radio'
							selected={f.label === answers.factor}
						/>
					))}
				</div>
			</fieldset>
			<Footer
				disableNext={!answers.factor}
				onClickNext={() => {
					trackEvent('userProgramQuizQuestionCompleted', analyticsData);
					nextScreen();
				}}
				onClickPrevious={previousScreen}
			/>
		</div>
	);
};
